import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import { onMobileNavToggle, toggleCollapsedNav } from "redux/actions/Theme";
import { useEffect, useState } from "react";

import { Layout } from "antd";
import Logo from "./Logo";
import NavNotification from "./NavNotification";
import { NavProfile } from "./NavProfile";
import NavSearch from "./NavSearch";
import { connect } from "react-redux";
import { useAuth } from "contexts/useAuth";
import utils from "utils";

const { Header } = Layout;

export const HeaderNav = (props) => {


  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props;
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });
  const auth = useAuth();


  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: 'rgba(5, 32, 78, 1)' }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  style={{ color: "#fff" }}
                  onClick={() => {
                    onToggle();
                  }}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
            </ul>
          </div>

          <div
            className="nav-right"
            style={{ display: "flex", alignItems: "center" }}
          >

            <h2 style={{ fontSize: "20px", marginTop: "8px", color: '#fff', marginRight: '.25em' }}>
              {auth.profile.user}
            </h2>
            {auth.profile.user && auth.profile.nickname && (
              <h2 style={{ fontSize: "20px", marginTop: "8px", color: '#fff', marginRight: '.25em' }}>-</h2>
            )}
            <h2 style={{ fontSize: "20px", marginTop: "8px", color: '#fff', marginRight: '1em' }}>
              {auth.profile.nickname}
            </h2>
            <NavNotification
            />
            <NavProfile />
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
